<heading-page>
    <div class="bg-gray-800 p-8 rounded-lg">
        <div>
            <nav class="sm:hidden" aria-label="Back">
                <a href="#" class="flex items-center text-sm font-medium text-gray-400 hover:text-gray-200">
                    <svg class="-ml-1 mr-1 size-5 shrink-0 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                    <path fill-rule="evenodd" d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd" />
                    </svg>
                    Indietro
                </a>
            </nav>
            <breadcrumb>
                <breadcrumb-item ckey="{ props.ckey }" link="" text="{ props.text }" />
            </breadcrumb>
        </div>
        <div class="mt-2 md:flex md:items-center md:justify-between">
            <div class="min-w-0 flex-1">
                <h2 class="text-2xl/7 font-bold text-white sm:truncate sm:text-3xl sm:tracking-tight">{ props.text }</h2>
            </div>
        </div>
    </div>

    <script>
        import StoreService from '/src/services/store'
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {

            onBeforeMount(props, state) {
                this.state = {
                    text: props.text,
                    search_text: '',
                    has_upload_xls: false
                }

                eventBus.on(EVENTS.UI.UPDATE_HEADING, this.handleUpdateHeading)
            },

            async onMounted(props, state) {
                const progetto_id = props.progetto_id
                const progetto = await StoreService.fetchProgettoById(progetto_id)
                this.update({
                    has_upload_xls: progetto.get('has_upload_xls')
                })
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.UI.UPDATE_HEADING, this.handleUpdateHeading)
            },

            edit(e) { // FIXME
                this.update({
                    search_text: e.target.value.toLowerCase()
                })
            },

            handleUpdateHeading(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        text: e.text
                    });
                }
            },

            search(e) { // FIXME
                e.preventDefault()
                eventBus.trigger(EVENTS.ITEMS.SEARCH, {
                    ckey: this.props.ckey,
                    search_text: this.state.search_text
                })
            },

            refresh(e) { // FIXME
                eventBus.trigger(EVENTS.ITEMS.REFRESH, {
                    ckey: this.props.ckey
                })
            },

            create(e) { // FIXME
                eventBus.trigger(EVENTS.ITEMS.CREATE, {
                    ckey: this.props.ckey
                })
            }
        }

    </script>
</heading-page>